import useTranslation from 'next-translate/useTranslation'
import React, { useState } from 'react'
import useTruckPlates from 'tennders-market/truck/hooks/useTruckPlates'
import { MYTRUCKS_EDIT_TRUCKS, QC_PANEL_EDIT_TRANSACTION, TRUCK_BOARD_EDIT_TRUCK } from 'tennders-stracture/libs/permissions'
import BookRate from 'tennders-transactions/views/common/BookRate'
import Company from 'tennders-transactions/views/common/Company'
import FindTruckButton from 'tennders-transactions/views/common/FindTruckButton'
import NotAssigned from 'tennders-transactions/views/common/NotAssigned'
import RefNumber from 'tennders-transactions/views/common/RefNumber'
import DOMPurify from 'dompurify'
import MPTag from 'tennders-transactions/views/common/TagMP'
import GHref from 'tennders-market/common/components/element/GHref'
import { copyToClipboard } from 'tennders-stracture/libs/utils'
import { copyPlatesMyBoardBoardView } from 'tennders-stracture/libs/copyText'
import usePermissions from 'tennders-auth/hooks/usePermissions'
import DeleteButton from 'tennders-transactions/views/common/DeleteButton'
import EditButton from 'tennders-transactions/views/common/EditButton'
import useSession from 'tennders-auth/hooks/useSession'
import { ItemTypes } from 'tennders-common/enums/ItemTypes'
import { LoadTruck } from 'tennders-common/enums/LoadTruck'
import { ServiceTypes } from 'tennders-common/enums/ServiceTypes'
import { STATUS_CANCELLED, STATUS_READY_TO_PAIR } from 'tennders-stracture/libs/constants'
import { useToast } from 'tennders-common/hooks/useToast'
import IconCopy from '../../../../../icons/icon-copy.svg'

const DetailedTruckView = ({ transaction, truck, close }) => {
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const { updatePlateNumbers } = useTruckPlates()
  const { isBrokerUser, isMe, isShipper } = useSession()
  const { ableTo } = usePermissions()
  const [copied, setCopied] = useState(false)

  return (
    <div className="w-50">
      <div key="detailed-truck-view" className="pr-10">
        <div
          className="d-flex column justify-space align-center border-b pb-8 mb-8"
          style={(transaction?.matchedTruck || transaction?.matchedLoad) && isBrokerUser ? { height: 78 } : null}
        >
          <div className="d-flex justify-space align-center w-100" style={{ height: 24 }}>
            <h3 className="d-flex w-100 bold mb-0">{t('transaction:truckInformation')}</h3>
            {(truck && !isShipper()) && (
              <>
                <div className="pr-10" />
                {!transaction.disabledActions.includes('EDIT_TRUCK') && (
                  <EditButton transaction={transaction} type={ItemTypes.TRUCK} board="transactionDetail" close={close} />
                )}
                {!transaction.disabledActions.includes('DELETE_TRUCK') && (
                  <DeleteButton
                    transaction={transaction}
                    isDeleteButton
                    type={ItemTypes.TRUCK}
                    board="transactionDetail"
                    closeTransaction={close}
                  />
                )}
              </>
            )}
          </div>
          {transaction && isBrokerUser && (
            transaction?.matchedTruck?.isMarketPlaced
              ? (
                <div className="d-flex justify-space align-center w-100 mt-10 mb-10">
                  <MPTag />
                </div>

              )
              : transaction?.matchedTruck
                ? (
                  <div className="d-flex justify-space align-center w-100 mt-10 mb-10">
                    <span className={'text-12 lh-1 p-6 t-state-text ' + (transaction?.matchedTruck?.internalOwner ? 'is-internal' : 'is-external')}>
                      #{t('transaction:' + (transaction?.matchedTruck?.internalOwner ? 'internal' : 'external'))}
                    </span>
                  </div>
                )
                : null
          )}
        </div>
        {!truck ? ((transaction?.bookedBy?.name && isShipper()) ? (
          <>
            {t('transaction:truck_details_soon')}
          </>
        ) : (
          <>
            <NotAssigned />
            { transaction.isOpenToQC && transaction.status?.label === STATUS_READY_TO_PAIR ? <FindTruckButton transaction={transaction} withIcon={false} /> : null}
          </>
        )) : (
          <>
            <div className="d-flex mb-10">
              <div className="w-auto">
                <img src="/icons/icon-truck-info.svg" alt={t('transaction:truckInformation')} width="40" />
              </div>
              <Company documentType="CMR" {...truck} />
            </div>
            {truck?.pointOfContact ? <><span className="bold" style={{ fontSize: 13 }}>{t('transaction:poc')}:</span> {truck.pointOfContact?.name}</> : null}
            <div
              className="text-12 mb-10"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(truck?.allDetails) }}
            />
            <div className="text-12 mb-16">
              { (truck.truckPlate || truck.trailerPlate) ? (
                <div className="w-100">
                  <div
                    className="pr-10 cursor-pointer d-flex align-center"
                    onClick={() => {
                      copyToClipboard(copyPlatesMyBoardBoardView({ matchedTruck: truck }))
                      setCopied(true)
                      toastSuccess(t('common:copied'))
                      setTimeout(() => setCopied(false), 500)
                    }}
                  >
                    {!copied ? (
                      <>
                        <div className="d-grid">
                          {truck?.truckPlate ? (
                            <span>
                              {t('transaction:truckPlateNumber')}
                              {': '}
                              <strong>
                                {truck.truckPlate}
                              </strong>
                            </span>
                          ) : null}
                          {truck?.trailerPlate ? (
                            <span>
                              {t('transaction:trailerPlateNumber')}
                              {': '}
                              <strong>
                                {truck.trailerPlate}
                              </strong>
                            </span>
                          ) : null}
                        </div>
                        <IconCopy className="icon-small" />
                      </>
                    ) : t('transaction:copied')}
                  </div>
                </div>
              ) : null}
              {(truck?.isPartiallyEditable || ableTo([
                MYTRUCKS_EDIT_TRUCKS,
                TRUCK_BOARD_EDIT_TRUCK,
                QC_PANEL_EDIT_TRANSACTION
              ])) && !transaction?.matchedTruck?.isMarketPlaced && transaction?.status?.label !== STATUS_CANCELLED && (
                <>
                  <GHref className="btn-link text-underline" onClick={() => updatePlateNumbers(transaction)}>
                    {t('transaction:updatePlateNumbers')}
                  </GHref>
                </>
              )}
              <br />
              {(truck?.isPartiallyEditable || ableTo([
                MYTRUCKS_EDIT_TRUCKS,
                TRUCK_BOARD_EDIT_TRUCK,
                QC_PANEL_EDIT_TRANSACTION
              ])) && (truck.serviceType?.value === ServiceTypes.DEDICATED && !transaction?.pickupRoute) && (
                <>
                  <GHref className="btn-link text-underline" href={`/edit/truck/${transaction.matchedTruck && transaction.matchedTruck.id}`}>
                    {`${t('transaction:define_start_location')}`}
                  </GHref>
                </>
              )}
            </div>
            {(isBrokerUser || isMe(transaction?.matchedTruck?.createdBy)) && (
              <BookRate {...truck} transaction={transaction} isAbout={LoadTruck.truck} />
            )}
            <RefNumber {...truck} />
          </>
        )}
      </div>
    </div>
  )
}

export default React.memo(DetailedTruckView)
